import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient.ts';
import AdoptionShop from './AdoptionShop.js';
import NewArrivals from './NewArrivals .js';

function Counter() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 680);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const [promoSlider, setPromoSlider] = useState(null);

  useEffect(() => {
    const fetchPromoSlider = async () => {
      const { data, error } = await supabase
        .from('promotion_slider')
        .select('*')
        .order('order_index', { ascending: true })
        .limit(1)
        .single();

      if (!error) setPromoSlider(data);
    };

    fetchPromoSlider();
  }, []);


  return (
    <>

      <NewArrivals />
      <AdoptionShop />



    </>

  );
}

export default Counter;
